export const brandColours = {
  eirquest: '#006834',
  cymruquest: '#bc3019',
  turquest: '#4a738f',
  myaptitude: '#ca4e87',
  myaptitudecore: '#ca4e87',
  mycareerchoices: '#4a738f',
  myfirstchoices: '#f5874f',
  myunichoices: '#56bbaf',
  completesuite: '#8c67ac', // MySupportPortal Purple
  degreecoursedescriptions: '#56bbaf', // not really used, needed for App.Enums.ProgrammeTheme
}

export const brandColoursExtended = {
  myaptitude : {
    lighter: '#e482b6',
    darker: '#8d2752',
    default: brandColours.myaptitude,
  },
  myaptitudecore : {
    lighter: '#e482b6',
    darker: '#8d2752',
    default: brandColours.myaptitudecore,
  },
  mycareerchoices : {
    lighter: '#81a5be',
    darker: '#273d4c',
    default: brandColours.mycareerchoices,
  },
  eirquest : {
    lighter: '#00a245',
    darker: '#003b1a',
    default: brandColours.eirquest,
  },
  cymruquest : {
    lighter: '#f25a41',
    darker: '#81291b',
    default: brandColours.cymruquest,
  },
  turquest : {
    lighter: '#81a5be',
    darker: '#273d4c',
    default: brandColours.turquest,
  },
  myfirstchoices : {
    lighter: '#fac9b0',
    darker: '#d24f0c',
    default: brandColours.myfirstchoices,
  },
  myunichoices : {
    lighter: '#97d6cf',
    darker: '#458f86',
    default: brandColours.myunichoices,
  },
  degreecoursedescriptions : { // not really used, needed for App.Enums.ProgrammeTheme
    lighter: '#97d6cf',
    darker: '#458f86',
    default: brandColours.degreecoursedescriptions,
  },
}

export const chartColoursArray = [
  brandColours.mycareerchoices,
  brandColours.myaptitude,
  brandColours.myunichoices,
  brandColours.myfirstchoices,
]

export const progressColoursArray = {
  notStarted: '#FF9F43', // warning
  inProgress: '#00CFE8', // info
  completed: '#28C76F', // success
  exploringResults: '#1B8B4D', // success-dark-3 equivalent
}
